import clone from 'clone';
import moment from 'moment';
import * as uuid from 'uuid';
import { t } from '../../../i18n';

export const recurrenceType = {
  once_off: 'once_off',
  daily: 'daily',
  weekly: 'weekly',
};

export const validate = (attr, value, params = { durationData: {}, day: undefined }) => {
  let error = '';

  // address
  if (attr === 'addressData' && (value.longitude === undefined || value.longitude === null)) {
    error = t('dash.validation.valid_error', { fieldName: t('dash.orientations.address_label') });
  }

  // starts_at, finishes_at
  if (attr === 'starts_at' || attr === 'finishes_at') {
    // Check if start time is after current for today date
    if (
      params.day &&
      params.day.date &&
      moment(params.day.date, 'DD/MM/YYYY').isSame(moment(), 'day') &&
      attr === 'starts_at' &&
      moment(value, 'HH:mm').isBefore(moment())
    ) {
      error = 'sessions.errorBookingStartTimeBeforeCurrentTime';
    }

    // Check duration
    if (params.durationData && params.durationData.duration < params.durationData.minBookingDurationHours * 60) {
      error = 'sessions.errorBookingDuration';
    } else if (!value) {
      // Check if times are not empty
      error = attr === 'starts_at' ? 'sessions.errorBookingStart' : 'sessions.errorBookingEnd';
    }
  }

  return error;
};

export const initInputField = (name, value = null, touched = false, blurred = false) => {
  return {
    value,
    name,
    error: validate(name, value),
    touched,
    blurred,
  };
};

export const getInitialDayFormData = ({
  startsAt,
  minBookingDurationHours,
  /* date, timeZoneId, disabledTimeData */
}) => {
  const finishesAt = moment(startsAt, 'HH:mm')
    .add(minBookingDurationHours || 4, 'h') // 4 hours
    .format('HH:mm');

  const newDay = {
    uuid: uuid.v4(),
    position: initInputField('position', 'New Recruits'),
    workers_required: initInputField('workers_required', 1),
    starts_at: initInputField('starts_at', startsAt),
    finishes_at: initInputField('finishes_at', finishesAt),
    attire_items: initInputField('attire_items', []),
    special_instructions: initInputField('special_instructions', ''),
    error: '',
    warning: '',
  };

  /* if (date && timeZoneId && disabledTimeData && minBookingDurationHours) {
    handleBookingTimeFields({
      date,
      booking: newBooking,
      timeZoneId,
      disabledTimeData,
      minBookingDurationHours,
    });
  } */

  return newDay;
};

export const initAddressData = address => {
  return {
    address: address || '',
    street: null,
    street2: null,
    zip: null,
    city: null,
    state: null,
    latitude: null,
    longitude: null,
  };
};

export const cloneBooking = ({ from, positions, to, attr }) => {
  let clonedBooking;

  if (attr && to) {
    // Clone only 1 attribute
    clonedBooking = to;

    if (attr === 'starts_at') {
      clonedBooking.finishesAt = clone(from.finishesAt);
    }

    if (attr === 'position') {
      const currentPosition = positions.find(position => position.id === clonedBooking.position.value);
      clonedBooking.tiers.value = currentPosition && currentPosition.skills;
    }

    if (attr === 'position') {
      clonedBooking.tier.value = null;
      clonedBooking.tiers.value = from.tiers.value;
    }
  } else {
    // Clone entire booking
    const { uuid: _uuid, ...allBookingProps } = from;
    clonedBooking = clone({ uuid: uuid.v4(), ...allBookingProps });

    if (clonedBooking.latest_starts_at) {
      clonedBooking.latestStartsAt.value = null;
    }
  }

  return clonedBooking;
};

export const getBookingDuration = (startsAtValue, finishesAtValue) => {
  const startsAtMoment = moment(startsAtValue, 'HH:mm');
  const finishesAtMoment = moment(finishesAtValue, 'HH:mm');
  const isNextDay =
    (startsAtMoment.format('A') === 'PM' && finishesAtMoment.format('A') === 'AM') ||
    finishesAtMoment.diff(startsAtMoment, 'minutes') < 0;

  return isNextDay
    ? finishesAtMoment.add(1, 'd').diff(startsAtMoment, 'minutes')
    : finishesAtMoment.diff(startsAtMoment, 'minutes');
};

export const validate12and15hoursDurations = booking => {
  const startTimeValue = booking.starts_at.value;
  const duration = getBookingDuration(startTimeValue, booking.finishes_at.value);
  booking.error = duration > 15 * 60 ? 'sessions.errorBookingShiftDurationOver15Hours' : '';
  booking.warning = duration >= 12 * 60 && duration <= 15 * 60 ? 'sessions.warningBookingShiftDurationOver12Hours' : '';
};

export const isAddressSelected = addressForm => {
  return (
    addressForm &&
    addressForm.address &&
    addressForm.address.value &&
    addressForm.address.value.longitude &&
    addressForm.address.value.latitude
  );
};

export const isBookingCreated = bookingForm => {
  return (
    bookingForm &&
    bookingForm.days &&
    bookingForm.days.value &&
    bookingForm.days.value[0] &&
    bookingForm.days.value[0].date
  );
};

export const isFormErrors = form => {
  return Object.values(form)
    .filter(value => value && typeof value === 'object' && value.error !== undefined)
    .some(value => value && value.error !== '');
};

export const getDefaultStartTime = () => '08:00';
